module.exports = __webpack_public_path__ + "static/img/pirateFishing-s.7dbc974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/pirateFishing-s.png
// module id = iBgm
// module chunks = 0